// extracted by mini-css-extract-plugin
export var socialsList = "index-module--socials-list--70d0e";